import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PlenaLogo } from "@/components/brand/PlenaLogo";
import { useAuth } from "./AuthContext";
import { errText } from "@/lib/api";

export default function LoginPage() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="fade-up w-full max-w-sm">
        <div className="mb-10 flex flex-col items-start gap-3">
          <PlenaLogo height={30} />
          <p className="eyebrow">Yönetim Konsolu</p>
        </div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Giriş yapın</h1>
        <p className="mt-1 text-sm text-plena-text2">Aday değerlendirme çalışmalarını yönetmek için oturum açın.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div className="space-y-1.5">
            <Label htmlFor="email">E-posta</Label>
            <Input id="email" data-testid="login-email-input" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-11 rounded-[10px]" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Şifre</Label>
            <Input id="password" data-testid="login-password-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-11 rounded-[10px]" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-plena-coral" role="alert">{error}</p>}
          <Button data-testid="login-submit-button" type="submit" disabled={busy} className="btn-press h-11 w-full rounded-[10px] text-sm font-semibold">
            {busy ? "Giriş yapılıyor…" : "Giriş Yap"}
          </Button>
        </form>
      </div>
    </div>
  );
}
